export default __webpack_public_path__ + "static/media/home-5.e5ea8841.png";